<div class="susceptibility comp" *ngIf="model">
   <div class="container-fluid content pt-3 mt-5">
      <h2>{{ model.meta.title }}</h2>
      <markdown class="publications_md" lineNumbers [start]="5">{{ model.content }}</markdown>
   </div>
</div>
